import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useEffect, useRef } from 'react';

import { TextButton } from '@flipster/react/design-system/text-button';
import { Explain } from '@flipster/react/design-utils/explain';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import { formSegmentDataBunja } from './bunja/form-segment-data';

interface Props {
  message: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

const ErrorMessage = ({ message, action }: Props) => {
  const { symbol, orderByTokenAtom, leverageAtom } = useBunja(formSegmentDataBunja);
  const prevMessageRef = useRef<string>(undefined);
  const leverage = useAtomValue(leverageAtom);
  const orderByToken = useAtomValue(orderByTokenAtom);

  useEffect(() => {
    if (message === prevMessageRef.current) return;
    prevMessageRef.current = message;
    segment.track(TradeEvent.OrderFormErrorMsgView, {
      error_message: message,
      error_case: 'open_position',
      is_recommendation_chip_visible: false,
      symbol,
      leverage,
      order_by_token: orderByToken,
    });
  }, [message, orderByToken, symbol, leverage]);

  return (
    <Explain.Error
      hideIcon
      css={{
        textStyle: 'Text/S/Regular',
        display: 'inline',
      }}
    >
      {message}{' '}
      {action && (
        <TextButton
          color='sell'
          onClick={() => {
            segment.track(TradeEvent.OrderFormErrorMsgClick, {
              error_message: message,
              error_case: 'open_position',
              symbol,
              leverage,
              order_by_token: orderByToken,
            });
            action.onClick();
          }}
          label={action.label}
          size='small'
        />
      )}
    </Explain.Error>
  );
};

export default ErrorMessage;
